<div>
  <!-- Admin Users Table -->
  <p-table
    #table
    [scrollable]="true"
    scrollHeight="flex"
    [value]="adminUsers()"
    [loading]="loading()"
    [paginator]="true"
    [rows]="queryParams().limit"
    [totalRecords]="totalRecords()"
    [first]="first"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="rowsPerPageOptions"
    currentPageReportTemplate="{first}-{last} of {totalRecords}"
    [stripedRows]="true"
    (onPage)="onPageChange($event)"
  >
    <!-- Table Caption with Search and Add Button -->
    <ng-template pTemplate="caption">
      <div class="flex flex-col md:flex-row gap-3 md:gap-2">
        <div class="flex gap-2">
          <p-button
            label="{{ 'adminUsers.addAdminUser' | translate }}"
            icon="pi pi-plus"
            severity="success"
            [disabled]="loading()"
            [loading]="loading()"
            (onClick)="addAdminUser()"
          >
          </p-button>
        </div>
        <p-iconfield iconPosition="left" class="md:ml-auto w-full md:w-auto">
          <p-inputicon>
            <i class="pi pi-search"></i>
          </p-inputicon>
          <input
            #searchInput
            pInputText
            type="text"
            [formControl]="searchControl"
            [placeholder]="'adminUsers.searchPlaceholder' | translate"
            class="w-full"
          />
        </p-iconfield>
      </div>
    </ng-template>

    <!-- Table Header -->
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="email" style="min-width: 250px">
          {{ 'adminUsers.email' | translate }}
          <p-sortIcon field="email"></p-sortIcon>
        </th>
        <th pSortableColumn="username" style="min-width: 200px">
          {{ 'adminUsers.username' | translate }}
          <p-sortIcon field="username"></p-sortIcon>
        </th>
        <th style="min-width: 150px">{{ 'adminUsers.actions' | translate }}</th>
      </tr>
    </ng-template>

    <!-- Table Body -->
    <ng-template pTemplate="body" let-adminUser>
      <tr>
        <td style="min-width: 250px">{{ adminUser.email }}</td>
        <td style="min-width: 200px">{{ adminUser.username }}</td>
        <td style="min-width: 150px">
          <div class="flex gap-2">
            <p-button
              icon="pi pi-pencil"
              [rounded]="true"
              size="small"
              [disabled]="loading()"
              [ariaLabel]="'adminUsers.edit' | translate"
              (onClick)="editAdminUser(adminUser)"
            >
            </p-button>
            <p-button
              icon="pi pi-trash"
              [rounded]="true"
              size="small"
              [disabled]="loading()"
              [ariaLabel]="'adminUsers.delete' | translate"
              (onClick)="deleteAdminUser(adminUser)"
            >
            </p-button>
          </div>
        </td>
      </tr>
    </ng-template>

    <!-- Empty state -->
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="3" class="text-center py-8">
          <div class="flex flex-col items-center gap-3">
            <i class="pi pi-users text-4xl text-muted"></i>
            <p class="text-body-md text-muted">{{ 'adminUsers.noData' | translate }}</p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- Confirmation Dialog -->
  <p-confirmDialog></p-confirmDialog>
</div>
